import { createRoot } from 'react-dom/client';
import i18n from '../../../i18n/client-i18n';
import { createWelcomePageApp } from './createWelcomePageApp.js';
import { LogoUrlGenerator } from '@wix/branding-client-lib';
import { userAgentDetector, origins } from '@wix/branding-logo-client/exports/clientServices';
import { ENGLISH_SYMBOL } from '../../../common/consts/preBoardingConsts';
import { welcomePageBiReporter } from './welcomePageBiReporter';

import '@wix/design-system/styles.global.css';

const initialI18n = window.__INITIAL_I18N__;
const referralAdditionalInfo = window.__REFERRAL_ADDITIONAL_INFO__;
const experiments = window.__EXPERIMENTS__;
const basename = window.__BASE_PATH__;
const debugApp = window.__DEBUG_APP__;
const companyDetails = window.__COMPANY_DETAILS__;
const queryParams = window.__QUERY_PARAMS__;
const i19n = i18n(initialI18n);
const logoUrlGenerator = new LogoUrlGenerator({ protocol: window.location.protocol, host: window.location.host, mountPoint: basename, debugApp });
const biReporter = new welcomePageBiReporter();
const shouldShowHireDesigner = i19n.language === ENGLISH_SYMBOL;
const options = { shouldShowHireDesigner };

function redirectOnBoarding() {
  biReporter.reportGoToOnboarding(shouldShowHireDesigner);
  const { companyName } = companyDetails;

  const additionalParams = { ...queryParams };
  additionalParams.referralAdditionalInfo = origins.WELCOME_PAGE;
  delete additionalParams.debugApp;

  const finalParams = Object.entries(additionalParams).map(([key, value]) => {
    return { key, value };
  });

  const onboardingUrl = companyName ? logoUrlGenerator.getIndustryOnboardingUrl(finalParams) : logoUrlGenerator.getHomePageUrl(finalParams);

  window.location.href = onboardingUrl;
}

if (userAgentDetector.isReactWebview()) {
  redirectOnBoarding();
} else {
  const app = createWelcomePageApp({
    i19n,
    experiments,
    biReporter,
    companyDetails,
    queryParams,
    origins,
    logoUrlGenerator,
    referralAdditionalInfo,
    options
  });
  const root = createRoot(document.getElementById('root'));
  root.render(app);
}
